import { render, staticRenderFns } from "./updateLocationData.vue?vue&type=template&id=63a97e32&"
import script from "./updateLocationData.vue?vue&type=script&lang=js&"
export * from "./updateLocationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports